
	<h2 class="pl-2 pt-2 pb-2 mb-0">
		<div class="flex justify-content-start, align-content-center">
			<CustomTitle [title]="getMenuTitle()" 
        styleClass="font-principal app-title-page-color font-medium font-18" />
		</div>
	</h2>

	<div [ngSwitch]="Type">
		<div *ngSwitchCase="'global'">
			<app-global-options></app-global-options>
		</div>
		<div *ngSwitchCase="'page'">
			<app-page-options></app-page-options>
		</div>
		<div *ngSwitchCase="'control'">
			<app-control-options></app-control-options>
		</div>
		<div *ngSwitchDefault>
			N/A
		</div>
	</div>
